import React, { useCallback, useEffect, useState } from "react";
import './style.scss';
import { Link, useHistory, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Logout } from "../../api/auth";
import { Divider, Menu, MenuItem } from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import SettingsIcon from "@material-ui/icons/Settings";
import gsap from 'gsap'
import { selectAuthstate } from "../../slices/auth";
import { openDialog } from "../../slices/dialog";
import { RequestDemo } from "../Dialog/RequestDemo";
import ButtonCircle from "../Common/ButtonCircle";
import MyBadge from "../Common/Badge";
import { Cookies } from "react-cookie-consent";
import { selectChangeSidebar } from "../../slices/management";
import Button from "../Common/Button";
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import TranslateIcon from '@material-ui/icons/Translate';
import {useTranslation} from "react-i18next";
import {ROUTES} from "../../db/models/const";
import {selectRole} from "../../slices/profile";

const logo = require("../../assets/logo.png");

const Toolbar = () => {
    // const darkMode = useSelector((store) => store.darkMode);
    let history = useHistory();
    const user = useSelector(selectAuthstate);
    const changeSidebar = useSelector(selectChangeSidebar);
    const verified = user?.verified;
    const role = useSelector(selectRole);
    const dispatch = useDispatch();
    const [rightMenuAnchor, setRightMenuAnchor] = useState(null);
    const [talentMenuAnchor, setTalentMenuAnchor] = useState(null);
    const [companyMenuAnchor, setCompanyMenuAnchor] = useState(null);
    const [languageMenuAnchor, setLanguageMenuAnchor] = useState(null);
    const { t, i18n } = useTranslation();
    const [showLogin, setShowLogin] = useState();
    const [showToolbar, setShowToolbar] = useState();
    const location = useLocation();

    useEffect(() => {
        const pathName = location.pathname;

        const showToolbar = !(pathName.includes("onboarding"));
        setShowToolbar(showToolbar);

        const showLogin = !(pathName.includes("public/rm"));
        setShowLogin(showLogin);
    }, [location])

    // const onDarkModeClick = () => {
    //     const current = darkMode;
    //     dispatch({
    //         type: STORE_DARK_MODE,
    //         payload: {
    //             darkMode: !current,
    //         },
    //     });
    //     localStorage.setItem("darkMode", !current);
    // };


    const onLogout = () => {
        rightMenuClose();
        Logout(dispatch).then(() => {
            // resetStore(dispatch);
            // history.push(ROUTES.STUDENT_HOME)
        });
    };

    const [menuOpen, setMenuOpen] = useState(false);
    const [menuLoading, setMenuLoading] = useState(false);

    /* Menu Animations and atoms */
    const changeMenuState = useCallback(() => {
        if (!menuLoading) {
            setMenuLoading(true);
            const tl = gsap.timeline()
            if (!menuOpen) {
                tl
                    .set('.sidebar', { display: 'inherit', xPercent: -100 })
                    .to('.sidebar', { duration: 0.1, xPercent: 0 })
                setMenuOpen(true);
            } else {
                tl
                    .to('.sidebar', { duration: 0.1, xPercent: -100 })
                    .set('.sidebar', { display: 'none', xPercent: -100 })
                setMenuOpen(false);
            }
            setTimeout(() => {
                setMenuLoading(false);
            }, 200);
        }
    }, [menuLoading, menuOpen]);

    useEffect(() => {
        if (changeSidebar === null) return;
        if (changeSidebar) changeMenuState();
    }, [changeSidebar])

    const openLogin = () => {
        rightMenuClose();
        // dispatch(openDialog({
        //     Content: Login,
        //     title: "Login",
        //     closable: true
        // }))
        history.push(ROUTES.LOGIN);
    }

    const onDemoRequest = () => {
        rightMenuClose();
        companyMenuClose();
        dispatch(openDialog({
            Content: RequestDemo,
            title: t("demo_title"),
            props: {},
            closable: true
        }))
    }

    const rightMenuClose = () => {
        setRightMenuAnchor(null);
    };

    const talentMenuClose = () => {
        setTalentMenuAnchor(null);
    };

    const companyMenuClose = () => {
        setCompanyMenuAnchor(null);
    };

    const languageMenuClose = () => {
        setLanguageMenuAnchor(null);
    };

    const onSettingsClick = () => {
        rightMenuClose();
        history.push(ROUTES.SETTINGS);
    }

    // const onTutorial = () => {
    //     if (role === "student") {
    //         Cookies.remove("feedTutorialDone");
    //         Cookies.remove("profileTutorialDone");
    //         Cookies.remove("rmTutorialDone");
    //     }
    //     if (role === "company") {
    //         Cookies.remove("areasTutorialDone");
    //         Cookies.remove("rmTutorialDone");
    //         Cookies.remove("shareTutorialDone");
    //         Cookies.remove("profileTutorialDone");
    //     }

    //     const path = window.location.pathname;
    //     if (path === "/me")
    //         window.location.reload();
    //     else
    //         history.push(ROUTES.ME);

    //     rightMenuClose();
    // }

    const goTo = (to) => {
        if (!to) return;

        rightMenuClose();
        talentMenuClose();
        companyMenuClose();

        history.push(to);
    }

    const onChangeLanguage = (lang) => {
        Cookies.set("language", lang, { expires: 1000 });

        languageMenuClose();
        i18n.changeLanguage(lang);
    };

    return (
        <>
            {showToolbar &&
                <div className="navbar">
                    {role &&
                        <>
                            <div style={{ padding: "10px" }} className="menu-icon" onClick={changeMenuState}>
                                <ButtonCircle><MenuIcon /></ButtonCircle>
                            </div>

                            {/* Steps icon */}
                            <Link to="/" className="logo">
                                <img
                                    style={{ height: "48px", width: "48px" }}
                                    src={logo}
                                    alt="Steps Logo"
                                />
                                <h2>Steps</h2>
                            </Link>

                            <div className="loggedButtons">
                                <div className="regularButton">
                                    <button aria-controls="language" aria-haspopup="true"
                                        onClick={e => setLanguageMenuAnchor(e.currentTarget)}>
                                        <TranslateIcon />
                                        <ArrowDropDownIcon />
                                    </button>
                                </div>
                                <Menu
                                    id="language"
                                    anchorEl={languageMenuAnchor}
                                    keepMounted
                                    open={Boolean(languageMenuAnchor)}
                                    onClose={languageMenuClose}
                                    elevation={1}
                                    getContentAnchorEl={null}
                                    anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                                    transformOrigin={{ vertical: "top", horizontal: "center" }}
                                >
                                    <MenuItem onClick={() => onChangeLanguage("it")}>Italiano</MenuItem>
                                    <MenuItem onClick={() => onChangeLanguage("en")}>English</MenuItem>
                                    {/* <MenuItem onClick={() => onChangeLanguage("de")}>Deutsch</MenuItem> */}
                                </Menu>

                                <MyBadge badgeContent={""} invisible={verified}>
                                    <div className="account">
                                        <ButtonCircle light={true} aria-controls="settings" aria-haspopup="true"
                                            onClick={e => setRightMenuAnchor(e.currentTarget)}><SettingsIcon /></ButtonCircle>
                                        <Menu
                                            id="settings"
                                            anchorEl={rightMenuAnchor}
                                            keepMounted
                                            open={Boolean(rightMenuAnchor)}
                                            onClose={rightMenuClose}
                                        >
                                            <MenuItem onClick={() => goTo("/")}>Home</MenuItem>
                                            <MyBadge badgeContent={""} invisible={verified}>
                                                <MenuItem onClick={() => onSettingsClick()}>Settings</MenuItem>
                                            </MyBadge>
                                            {/* <MenuItem onClick={() => onTutorial()}>Tutorial</MenuItem> */}
                                            <MenuItem onClick={() => onLogout()}>Logout</MenuItem>
                                        </Menu>
                                        {/* <div className="account__menu">
                                <MyBadge badgeContent={""} invisible={verified}>
                                    <div onClick={() => history.push("/settings")} className="account__menuItem">Settings</div>
                                </MyBadge>

                                <div className="account__menuItem" onClick={() => onLogout()}>Logout</div>
                            </div> */}
                                    </div>
                                </MyBadge>
                            </div>
                        </>
                    }
                    {!role &&
                        <>
                            <div className="logo">
                                <img
                                    style={{ height: "60px", width: "60px" }}
                                    src={require("../../assets/logo.png")}
                                    alt="Steps Logo"
                                />
                                <h2 onClick={() => history.push(ROUTES.STUDENT_HOME)}>Steps</h2>
                            </div>
                            <div className="links">
                                <div className="regularButton">
                                    <button
                                        aria-controls="talent"
                                        aria-haspopup="true"
                                        onClick={e => setTalentMenuAnchor(e.currentTarget)}
                                    // onMouseOver={e => setTalentMenuAnchor(e.currentTarget)}
                                    >{t("toolbar_talent_dropdown")} <ArrowDropDownIcon /></button>
                                </div>
                                <Menu
                                    id="talent"
                                    anchorEl={talentMenuAnchor}
                                    keepMounted
                                    open={Boolean(talentMenuAnchor)}
                                    onClose={talentMenuClose}
                                    elevation={1}
                                    getContentAnchorEl={null}
                                    anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                                    transformOrigin={{ vertical: "top", horizontal: "center" }}
                                >
                                    <MenuItem onClick={() => goTo("/")}>{t("toolbar_talent_explore")}</MenuItem>
                                    <MenuItem onClick={() => goTo("/emoji")}>{t("toolbar_talent_emoji")}</MenuItem>
                                </Menu>

                                <div className="regularButton">
                                    <button aria-controls="company" aria-haspopup="true"
                                        onClick={e => setCompanyMenuAnchor(e.currentTarget)}>{t("toolbar_company_dropdown")}<ArrowDropDownIcon />
                                    </button>
                                </div>
                                <Menu
                                    id="company"
                                    anchorEl={companyMenuAnchor}
                                    keepMounted
                                    open={Boolean(companyMenuAnchor)}
                                    onClose={companyMenuClose}
                                    elevation={1}
                                    getContentAnchorEl={null}
                                    anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                                    transformOrigin={{ vertical: "top", horizontal: "center" }}
                                >
                                    <MenuItem onClick={() => goTo("/company")}>{t("toolbar_company_explore")}</MenuItem>
                                    <MenuItem onClick={() => onDemoRequest()}>{t("toolbar_company_demo")}</MenuItem>
                                </Menu>

                                <div className="regularButton">
                                    <button onClick={() => goTo("/blog")}>Blog</button>
                                </div>

                                <div className="regularButton">
                                    <button aria-controls="language" aria-haspopup="true"
                                        onClick={e => setLanguageMenuAnchor(e.currentTarget)}>
                                        <TranslateIcon />
                                        <ArrowDropDownIcon />
                                    </button>
                                </div>
                                <Menu
                                    id="language"
                                    anchorEl={languageMenuAnchor}
                                    keepMounted
                                    open={Boolean(languageMenuAnchor)}
                                    onClose={languageMenuClose}
                                    elevation={1}
                                    getContentAnchorEl={null}
                                    anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                                    transformOrigin={{ vertical: "top", horizontal: "center" }}
                                >
                                    <MenuItem onClick={() => onChangeLanguage("it")}>Italiano</MenuItem>
                                    <MenuItem onClick={() => onChangeLanguage("en")}>English</MenuItem>
                                    {/* <MenuItem onClick={() => onChangeLanguage("de")}>Deutsch</MenuItem> */}
                                </Menu>

                                {showLogin && <Button filled onClick={() => openLogin()}>{t("toolbar_login")}</Button>}
                            </div>

                            <div className="mobilePublicRigth">
                                <div className="regularButton">
                                    <button aria-controls="language" aria-haspopup="true"
                                        onClick={e => setLanguageMenuAnchor(e.currentTarget)}>
                                        <TranslateIcon />
                                        <ArrowDropDownIcon />
                                    </button>
                                </div>
                                <Menu
                                    id="language"
                                    anchorEl={languageMenuAnchor}
                                    keepMounted
                                    open={Boolean(languageMenuAnchor)}
                                    onClose={languageMenuClose}
                                    elevation={1}
                                    getContentAnchorEl={null}
                                    anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                                    transformOrigin={{ vertical: "top", horizontal: "center" }}
                                >
                                    <MenuItem onClick={() => onChangeLanguage("it")}>Italiano</MenuItem>
                                    <MenuItem onClick={() => onChangeLanguage("en")}>English</MenuItem>
                                    {/* <MenuItem onClick={() => onChangeLanguage("de")}>Deutsch</MenuItem> */}
                                </Menu>
                                <div className="links-xs">
                                    <ButtonCircle light={true} aria-controls="settings" aria-haspopup="true"
                                        onClick={e => setRightMenuAnchor(e.currentTarget)}><MenuIcon /></ButtonCircle>
                                    <Menu
                                        id="settings"
                                        anchorEl={rightMenuAnchor}
                                        keepMounted
                                        open={Boolean(rightMenuAnchor)}
                                        onClose={rightMenuClose}
                                        elevation={1}
                                    >
                                        {showLogin &&
                                            <div>
                                                <MenuItem onClick={() => openLogin()}>{t("toolbar_login")}</MenuItem>
                                                <Divider />
                                            </div>
                                        }
                                        <MenuItem onClick={() => goTo("/blog")}>Blog</MenuItem>
                                        <Divider />
                                        <MenuItem onClick={() => goTo("/")}>{t("toolbar_talent_dropdown")}</MenuItem>
                                        <MenuItem onClick={() => goTo("/laurea")}>{t("toolbar_zero")}</MenuItem>
                                        <MenuItem onClick={() => goTo("/emoji")}>{t("toolbar_talent_emoji")}</MenuItem>
                                        <Divider />
                                        <MenuItem onClick={() => goTo("/company")}>{t("toolbar_company_dropdown")}</MenuItem>
                                        <MenuItem onClick={() => onDemoRequest()}>{t("toolbar_company_demo")}</MenuItem>
                                    </Menu>
                                </div>
                            </div>
                        </>
                    }
                </div>
            }
        </>
    );
};

export default Toolbar;